import styles from './TableComponent.module.scss';

export const TableComponent = () => {
	return (
		<table className={styles.table}>
			<thead>
			<tr>
				<th style={{ width: "10%" }}>Класс</th>
				<th style={{ width: "15%" }}>Подкласс</th>
				<th style={{ width: "30%" }}>RUB (Россия)</th>
				<th style={{ width: "25%" }}>USD+RUB (США + Европа)</th>
				<th style={{ width: "20%" }}>CNY (Китай) </th>
			</tr>
			</thead>
			<tbody>
			<tr className="Equity">
				<td className="s0" rowSpan={6}>Акции</td>
				<td className="s01">Основной индекс</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A101EJ5" className="vtb under">EQMX</a>
					<a href="https://rusetfs.com/etf/RU000A0ZZH92" className="sber under">SBMX</a>
					<a href="https://rusetfs.com/etf/RU000A101X76" className="tinkoff under">TMOS</a>
					<a href="https://rusetfs.com/etf/AMIX/overview" className="etc under">AMIX</a>
					<a href="https://rusetfs.com/etf/BCSR/overview" className="etc under">BCSR</a>
				</td>
				<td className="s2">
				</td>
				<td className="s4">
				</td>
			</tr>
			<tr className="Equity">
				<td className="s01">Tech компании</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/TITR/overview" className="tinkoff under">TITR</a>
					<a href="https://rusetfs.com/etf/AKHT/overview" className="alpha under">AKHT</a>
				</td>
				<td className="s2">
					<a href="https://rusetfs.com/etf/RU000A100VK9" className="etc under">MTEK</a>
				</td>
				<td className="s4"></td>
			</tr>
			<tr className="Equity">
				<td className="s01">Дивидендный фактор</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A102N02" className="etc under">DIVD</a>
					<a href="https://rusetfs.com/etf/RU000A103BX8" className="etc under">MKBD</a>
				</td>
				<td className="s2"></td>
				<td className="s4"></td>
			</tr>
			<tr className="Equity">
				<td className="s01">Прочие факторы</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/SBSC/overview" className="sber under">SBSC</a>
					<a href="https://rusetfs.com/etf/RU000A1024P8" className="sber under">SBRI</a>
					<a href="https://rusetfs.com/etf/RU000A103ZQ1" className="sber under">SBHI</a>
					<a href="https://rusetfs.com/etf/SBBC/overview" className="sber under">SBBC</a>
					<a href="https://rusetfs.com/etf/RU000A103H90" className="open under">OPNR</a>
					<a href="https://rusetfs.com/etf/AKBC/overview" className="alpha under">AKBC</a>
					<a href="https://rusetfs.com/etf/AKFN/overview" className="alpha under">AKFN</a>
					<a href="https://rusetfs.com/etf/AKCN/overview" className="alpha under">AKCN</a>
					<a href="https://rusetfs.com/etf/TRND/overview" className="tinkoff under">TRND</a>
					<a href="https://rusetfs.com/etf/RU000A103LL2" className="vtb under">ESGE</a>
					<a href="https://rusetfs.com/etf/SIPO/overview" className="sber under">SIPO</a>
					<a href="https://rusetfs.com/etf/RU000A101R66" className="rshb under">ESGR</a>
					<a href="https://rusetfs.com/etf/RU000A1037V8" className="etc under">GROD</a>
					<a href="https://rusetfs.com/etf/RU000A104FE7" className="etc under">SCFT</a>
				</td>
				<td className="s2">
				</td>
				<td className="s4"></td>
			</tr>
			<tr className="Equity">
				<td className="s01">Активное управление</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A10FF36" className="sber under">AIIQ</a>
					<a href="https://rusetfs.com/etf/RU000A103NR5" className="alpha under">AKQU</a>
					<a href="https://rusetfs.com/etf/AKIE/overview" className="alpha under">AKIE</a>
					<a href="https://rusetfs.com/etf/RU000A102E78" className="alpha under">AKME</a>
					<a href="https://rusetfs.com/etf/RU000A102XX4" className="etc under">AMRE</a>
					<a href="https://rusetfs.com/etf/WILD/overview" className="etc under">WILD</a>
					<a href="https://rusetfs.com/etf/PSRE/overview" className="etc under">PSRE</a>
					<a href="https://rusetfs.com/etf/FMSA/overview" className="etc under">FMSA</a>
					<a href="https://rusetfs.com/etf/TOPS/overview" className="etc under">TOPS</a>
				</td>
				<td className="s2"></td>
				<td className="s4"></td>
			</tr>

			<tr className="BlankRaw">
			</tr>
			<tr className="Debt">
				<td className="s0" rowSpan={5}>Облигации</td>
				<td className="s01">Денежный рынок</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A1014L8" className="vtb under">LQDT</a>
					<a href="https://rusetfs.com/etf/RU000A103RF1" className="sber under">SBMM</a>
					<a href="https://rusetfs.com/etf/RU000A10BXL5" className="sber under">FLOW</a>
					<a href="https://rusetfs.com/etf/AKMM/overview" className="alpha under">AKMM</a>
					<a href="https://rusetfs.com/etf/AKMP/overview" className="alpha under">AKMP</a>
					<a href="https://rusetfs.com/etf/TMON/overview" className="tinkoff under">TMON</a>
					<a href="https://rusetfs.com/etf/TPAY/overview" className="tinkoff under">TPAY</a>
					<a href="https://rusetfs.com/etf/AMNR/overview" className="etc under">AMNR</a>
					<a href="https://rusetfs.com/etf/PSMM/overview" className="etc under">PSMM</a>
					<a href="https://rusetfs.com/etf/SCLI/overview" className="etc under">SCLI</a>
					<a href="https://rusetfs.com/etf/BCSD/overview" className="etc under">BCSD</a>
					<a href="https://rusetfs.com/etf/FINC/overview" className="etc under">FINC</a>
					<a href="https://rusetfs.com/etf/FMMM/overview" className="etc under">FMMM</a>
					<a href="https://rusetfs.com/etf/GOOD/overview" className="etc under">GOOD</a>
					<a href="https://rusetfs.com/etf/CASH/overview" className="etc under">CASH</a>
					<a href="https://rusetfs.com/etf/OLIQ/overview" className="etc under">OLIQ</a>
					<a href="https://rusetfs.com/etf/NFKL/overview" className="etc under">NFKL</a>
					<a href="https://rusetfs.com/etf/MONY/overview" className="etc under">MONY</a>
					<a href="https://rusetfs.com/etf/SILA/overview" className="etc under">SILA</a>
				</td>
				<td className="s2">
				</td>
				<td className="s4">
					<a href="https://rusetfs.com/etf/AMNY/overview" className="etc under">AMNY</a>
					<a href="https://rusetfs.com/etf/CNYM/overview" className="vtb under" >CNYM</a>
					<a href="https://rusetfs.com/etf/SBCN/overview" className="sber under">SBCN</a>
					<a href="https://rusetfs.com/etf/AKMC/overview" className="alpha under">AKMC</a>
				</td>
			</tr>
			<tr className="Debt">
				<td className="s01">Госдолг</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A1000F9" className="sber under">SBGB</a>
					<a href="https://rusetfs.com/etf/SBLB/overview" className="sber under">SBLB</a>
					<a href="https://rusetfs.com/etf/TOFZ/overview" className="tinkoff under">TOFZ</a>
					<a href="https://rusetfs.com/etf/WOFZ/overview" className="vtb under">WOFZ</a>
					<a href="https://rusetfs.com/etf/AMGB/overview" className="etc under">AMGB</a>
					<a href="https://rusetfs.com/etf/SUGB/overview" className="etc under">SUGB</a>
					<a href="https://rusetfs.com/etf/OFZS/overview" className="etc under">OFZS</a>
				</td>
				<td className="s2">
				</td>
				<td className="s4"></td>
			</tr>
			<tr className="Debt">
				<td className="s01">Переменные купоны и индексация </td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/SBFR/overview" className="sber under">SBFR</a>
					<a href="https://rusetfs.com/etf/WFLO/overview" className="vtb under">WFLO</a>
					<a href="https://rusetfs.com/etf/AKFB/overview" className="alpha under">AKFB</a>
					<a href="https://rusetfs.com/etf/AMFL/overview" className="etc under">AMFL</a>
					<a href="https://rusetfs.com/etf/RU000A1047H6" className="etc under">INFL</a>
					<a href="https://rusetfs.com/etf/SMCF/overview" className="etc under">SMCF</a>
				</td>
				<td className="s2"></td>
				<td className="s4"></td>
			</tr>
			<tr className="Debt">
				<td className="s01">Корпоративные облигации</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A1002S8" className="vtb under">OBLG</a>
					<a href="https://rusetfs.com/etf/RU000A100P44" className="sber under">SBRB</a>
					<a href="https://rusetfs.com/etf/SECR/overview" className="sber under">SECR</a>
					<a href="https://rusetfs.com/etf/RU000A1035N9" className="sber under">SAFE</a>
					<a href="https://rusetfs.com/etf/RU000A101PN3" className="alpha under">AKMB</a>
					<a href="https://rusetfs.com/etf/RU000A1039N1" className="tinkoff under">TBRU</a>
					<a href="https://rusetfs.com/etf/RU000A102XY2" className="etc under">AMRB</a>
					<a href="https://rusetfs.com/etf/RU000A1009F0" className="etc under">GPBM</a>
					<a href="https://rusetfs.com/etf/RU000A1009E3" className="etc under">GPBS</a>
					<a href="https://rusetfs.com/etf/FMBR/overview" className="etc under">FMBR</a>
					<a href="https://rusetfs.com/etf/RU000A1038R4" className="etc under">SPBC</a>
					<a href="https://rusetfs.com/etf/RU000A103CA4" className="etc under">INGO</a>
					<a href="https://rusetfs.com/etf/RU000A104Z22" className="etc under">BOND</a>
					<a href="https://rusetfs.com/etf/BNDA/overview" className="etc under">BNDA</a>
					<a href="https://rusetfs.com/etf/BNDB/overview" className="etc under">BNDB</a>
					<a href="https://rusetfs.com/etf/BNDC/overview" className="etc under">BNDC</a>
					<a href="https://rusetfs.com/etf/PSRB/overview" className="etc under">PSRB</a>
					<a href="https://rusetfs.com/etf/CORP/overview" className="etc under">CORP</a>
					<a href="https://rusetfs.com/etf/ROBL/overview" className="etc under">ROBL</a>
				</td>
				<td className="s2" dir="ltr">
					<a href="https://rusetfs.com/etf/RU000A103TD2" className="tinkoff under">TBEU</a>
					<a href="https://rusetfs.com/etf/RU000A107597" className="tinkoff under">TLCB</a>
					<a href="https://rusetfs.com/etf/WUSD/overview" className="vtb under">WUSD</a>
					<a href="https://rusetfs.com/etf/RU000A1000Q6" className="sber under">SBCB</a>
					<a href="https://rusetfs.com/etf/RU000A101368" className="rshb under">RSHU</a>
					<a href="https://rusetfs.com/etf/RU000A1030R1" className="rshb under">PRIE</a>
					<a href="https://rusetfs.com/etf/AKGP/overview" className="alpha under" >AKGP</a>
					<a href="https://rusetfs.com/etf/AMVD/overview" className="etc under">AMVD</a>
					<a href="https://rusetfs.com/etf/BCSE/overview" className="etc under">BCSE</a>
					<a href="https://rusetfs.com/etf/RUFO/overview" className="etc under">RUFO</a>
				</td>
				<td className="s4">
					<a href="https://rusetfs.com/etf/SBBY/overview" className="sber under">SBBY</a>
					<a href="https://rusetfs.com/etf/AMVY/overview" className="etc under">AMVY</a>
					<a href="https://rusetfs.com/etf/YUAN/overview" className="etc under">YUAN</a>
				</td>
			</tr>
			<tr className="Debt">
				<td className="s01">Высокодоходные облигации</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/VDOR/overview" className="etc under">VDOR</a>
					<a href="https://rusetfs.com/etf/RU000A103FW1" className="etc under">AMRH</a>
					<a href="https://rusetfs.com/etf/RU000A102ST2" className="etc under">BCSB</a>
				</td>
				<td className="s2" dir="ltr">
				</td>
				<td className="s4"></td>
			</tr>
			<tr className="BlankRaw">
			</tr>
			<tr className="Commodity">
				<td className="s0" dir="ltr" rowSpan={1}>Товары</td>
				<td className="s01">Золото и серебро</td>
				<td className="s4 align-middle" colSpan={5}>
					<a href="https://rusetfs.com/etf/RU000A105385" className="sber under" >SBGD</a>
					<a href="https://rusetfs.com/etf/RU000A101NZ2" className="vtb under" >GOLD</a>
					<a href="https://rusetfs.com/etf/RU000A1045N8" className="alpha under" >AKGD</a>
					<a href="https://rusetfs.com/etf/AKPP/overview" className="alpha under" >AKPP</a>
					<a href="https://rusetfs.com/etf/RU000A101X50" className="tinkoff under">TGLD</a>
					<a href="https://rusetfs.com/etf/AMGL/overview" className="etc under">AMGL</a>
					<a href="https://rusetfs.com/etf/PSGM/overview" className="etc under">PSGM</a>
					<a href="https://rusetfs.com/etf/BCSG/overview" className="etc under">BCSG</a>
				</td>
			</tr>
			<tr className="BlankRaw">
			</tr>
			<tr className="Hybrid">
				<td className="s0" colSpan={2}>Недвижимость</td>
				<td className="s1 align-middle"></td>
				<td className="s2 align-middle"></td>
				<td className="s4 align-middle"></td>
			</tr>
			<tr className="BlankRaw">
			</tr>
			<tr className="Hybrid">
				<td className="s0" colSpan={2}>Смешанные</td>
				<td className="s1 align-middle">
					<a href="https://rusetfs.com/etf/RU000A1011U5" className="tinkoff under">TRUR</a>
					<a href="https://rusetfs.com/etf/AKUP/overview" className="alpha under">AKUP</a>
					<a href="https://rusetfs.com/etf/AKAI/overview" className="alpha under">AKAI</a>
					<a href="https://rusetfs.com/etf/RU000A1035R0" className="sber under">SBPS</a>
					<a href="https://rusetfs.com/etf/BCSW/overview" className="etc under">BCSW</a>
				</td>
				<td className="s2 align-middle">
					<a href="https://rusetfs.com/etf/RU000A1011S9" className="tinkoff under">TUSD</a>
					<a href="https://rusetfs.com/etf/RU000A1011T7" className="tinkoff under">TEUR</a>
					<a href="https://rusetfs.com/etf/WFUT/overview" className="vtb under">WFUT</a>
					<a href="https://rusetfs.com/etf/RU000A1035Q2" className="sber under">SBRS</a>
					<a href="https://rusetfs.com/etf/RU000A1035S8" className="sber under">STME</a>
					<a href="https://rusetfs.com/etf/SPRN/overview" className="sber under">SPRN</a>
					<a href="https://rusetfs.com/etf/RU000A1035L3" className="sber under">SBDS</a>
				</td>
				<td className="s4 align-middle"></td>
			</tr>
			</tbody>
		</table>
	);
}